/* tslint:disable */
/* eslint-disable */
/**
 * Public Track API
 * Public Track APIs provide customers access to their SPiDRs, Security Focuses and SPiDR Blueprints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CISControl = {
    _01InventoryAndControlOfEnterpriseAssets: '01. Inventory and Control of Enterprise Assets',
    _02InventoryAndControlOfSoftwareAssets: '02. Inventory and Control of Software Assets',
    _03DataProtection: '03. Data Protection',
    _04SecureConfigurationOfEnterpriseAssetsAndSoftware: '04. Secure Configuration of Enterprise Assets and Software',
    _05AccountManagement: '05. Account Management',
    _06AccessControlManagement: '06. Access Control Management',
    _07ContinuousVulnerabilityManagement: '07. Continuous Vulnerability Management',
    _08AuditLogManagement: '08. Audit Log Management',
    _09EmailAndWebBrowserProtections: '09. Email and Web Browser Protections',
    _10MalwareDefenses: '10. Malware Defenses',
    _11DataRecovery: '11. Data Recovery',
    _12NetworkInfrastructureManagement: '12. Network Infrastructure Management',
    _13NetworkMonitoringAndDefense: '13. Network Monitoring and Defense',
    _14SecurityAwarenessAndSkillsTraining: '14. Security Awareness and Skills Training',
    _15ServiceProviderManagement: '15. Service Provider Management',
    _16ApplicationSoftwareSecurity: '16. Application Software Security',
    _17IncidentResponseManagement: '17. Incident Response Management',
    _18PenetrationTesting: '18. Penetration Testing'
} as const;
export type CISControl = typeof CISControl[keyof typeof CISControl];


export function CISControlFromJSON(json: any): CISControl {
    return CISControlFromJSONTyped(json, false);
}

export function CISControlFromJSONTyped(json: any, ignoreDiscriminator: boolean): CISControl {
    return json as CISControl;
}

export function CISControlToJSON(value?: CISControl | null): any {
    return value as any;
}

